module.exports = __webpack_public_path__ + "static/img/normaldev.ca1bff89.png";